import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';
import { discoveryConfigByIdApi } from '../../ManageCMDBDiscoveredApps/data-store/getDiscoveryConfigByIdSlice';
import { type PatchDiscoveryStatusResponse } from '../data-layer/types';

export interface PatchDiscoveryStatusArgs {
  id: number;
  type: string;
  status: string;
}

const { CHANGE_DISCOVER_APP_STATUS } = getObNextGenApiUrlLists();

export const changeDiscoverAppStatusApi = createApi({
  reducerPath: 'changeDiscoverAppStatusApi',
  baseQuery: axiosBaseQuery({
    baseUrl: getBaseUrlObNextGen(),
  }),
  endpoints: (builder) => ({
    patchDiscoveryStatus: builder.mutation<
      PatchDiscoveryStatusResponse,
      PatchDiscoveryStatusArgs
    >({
      query: ({ id, type, status }) => ({
        url: `${CHANGE_DISCOVER_APP_STATUS}/${type}/status`,
        method: 'POST',
        data: {
          id,
          action: status,
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            discoveryConfigByIdApi.util.invalidateTags(['DiscoveryConfig'])
          );
        } catch {
          // ignore errors
        }
      },
    }),
  }),
});

export const { usePatchDiscoveryStatusMutation } = changeDiscoverAppStatusApi;
